import { CaseStudy } from '../types/CaseStudy';

export const caseStudies: CaseStudy[] = [
  {
    id: "1",
    slug: "manufacturing-automation",
    imageUrl:
      "https://images.unsplash.com/photo-1460925895917-afdab827c52f?auto=format&fit=crop&w=800&q=80",
    categoryEn: "Manufacturing",
    categoryFr: "Fabrication",
    titleEn: "50% Cost Reduction Through Automation",
    titleFr: "50% de Réduction des Coûts par l'Automatisation",
    descEn:
      "How we helped a manufacturing company reduce operational costs through smart automation.",
    descFr:
      "Comment nous avons aidé une entreprise à réduire ses coûts opérationnels grâce à l'automatisation intelligente.",
    contentEn: `
      <h2>Challenge</h2>
      <p>Our client, a leading manufacturing company, was facing increasing operational costs and inefficiencies in their production line.</p>
      
      <h2>Solution</h2>
      <p>We implemented a comprehensive automation solution that included:</p>
      <ul>
        <li>Smart sensors for real-time monitoring</li>
        <li>Automated quality control systems</li>
        <li>Predictive maintenance algorithms</li>
      </ul>
      
      <h2>Results</h2>
      <p>The implementation resulted in:</p>
      <ul>
        <li>50% reduction in operational costs</li>
        <li>35% increase in production efficiency</li>
        <li>90% decrease in quality control issues</li>
      </ul>
    `,
    contentFr: `
      <h2>Défi</h2>
      <p>Notre client, une entreprise manufacturière de premier plan, faisait face à des coûts opérationnels croissants et à des inefficacités dans sa ligne de production.</p>
      
      <h2>Solution</h2>
      <p>Nous avons mis en œuvre une solution d'automatisation complète comprenant :</p>
      <ul>
        <li>Des capteurs intelligents pour la surveillance en temps réel</li>
        <li>Des systèmes de contrôle qualité automatisés</li>
        <li>Des algorithmes de maintenance prédictive</li>
      </ul>
      
      <h2>Résultats</h2>
      <p>La mise en œuvre a abouti à :</p>
      <ul>
        <li>50% de réduction des coûts opérationnels</li>
        <li>35% d'augmentation de l'efficacité de production</li>
        <li>90% de diminution des problèmes de contrôle qualité</li>
      </ul>
    `,
    date: "2024-01-15",
  },
  {
    id: "2",
    slug: "healthcare-ai",
    imageUrl:
      "https://images.unsplash.com/photo-1504868584819-f8e8b4b6d7e3?auto=format&fit=crop&w=800&q=80",
    categoryEn: "Healthcare",
    categoryFr: "Santé",
    titleEn: "AI-Powered Patient Care",
    titleFr: "Soins aux Patients Optimisés par l'IA",
    descEn:
      "Implementing AI solutions to improve patient care and reduce wait times.",
    descFr:
      "Mise en œuvre de solutions d'IA pour améliorer les soins aux patients et réduire les temps d'attente.",
    contentEn: `
      <h2>Challenge</h2>
      <p>A major hospital was struggling with long wait times and inefficient patient care management.</p>
      
      <h2>Solution</h2>
      <p>We developed an AI-powered system that:</p>
      <ul>
        <li>Predicts patient flow and resource needs</li>
        <li>Optimizes staff scheduling</li>
        <li>Automates routine administrative tasks</li>
      </ul>
      
      <h2>Results</h2>
      <p>The implementation achieved:</p>
      <ul>
        <li>40% reduction in wait times</li>
        <li>25% improvement in resource utilization</li>
        <li>60% decrease in administrative workload</li>
      </ul>
    `,
    contentFr: `
      <h2>Défi</h2>
      <p>Un hôpital majeur était confronté à de longs temps d'attente et à une gestion inefficace des soins aux patients.</p>
      
      <h2>Solution</h2>
      <p>Nous avons développé un système basé sur l'IA qui :</p>
      <ul>
        <li>Prédit le flux de patients et les besoins en ressources</li>
        <li>Optimise la planification du personnel</li>
        <li>Automatise les tâches administratives routinières</li>
      </ul>
      
      <h2>Résultats</h2>
      <p>La mise en œuvre a permis :</p>
      <ul>
        <li>40% de réduction des temps d'attente</li>
        <li>25% d'amélioration de l'utilisation des ressources</li>
        <li>60% de réduction de la charge administrative</li>
      </ul>
    `,
    date: "2024-02-01",
  },
]; 